import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-[#0B0A1C]">
                <div className="text-cyan-400 text-sm uppercase tracking-widest">Đang xác thực…</div>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/dang-nhap" state={{ from: location.pathname }} replace />;
    }
    if (roles && roles.length && !roles.includes(user.role)) {
        return (
            <div className="container-x section text-center">
                <h1 className="text-2xl font-heading">Bạn không có quyền truy cập trang này</h1>
                <p className="text-slate-400 mt-2">Vai trò hiện tại: <strong>{user.role}</strong></p>
            </div>
        );
    }
    return children;
}
